import { createContext, useEffect, useState } from 'react';
import usePartner from '../hooks/usePartner';

export const PartnerContext = createContext({});
export const PartnerContextProvider = ({ children, props }) => {
  const urlSplit = window.location.host.split('.');
  const [ssoToken, setSsoToken] = useState(null);

  // Decode the auto auth key from the URL and update local storage and state
  useEffect(() => {
    const rawSearch = window.location.search; // Get the full raw query string
    const newSsoToken = rawSearch.match(/[?&]u=([^&]*)/)?.[1] || ''; // Extract manually
    setSsoToken(newSsoToken);
  }, []);

  const partnerObject = urlSplit.length > 1 ? usePartner(urlSplit[0], ssoToken) : {};
  // console.log('partnerObject: ', partnerObject);

  useEffect(() => {
    if (ssoToken && partnerObject?.auth_token) {
      const user = {
        ...partnerObject?.user,
        user_id: partnerObject?.user?.id,
        auth_token: partnerObject?.auth_token,
      };
      console.log('new user: ', user);

      localStorage.setItem('DQPN_AUTH', JSON.stringify(user));
      window.location = window.location.protocol + '//' + window.location.host + '/dashboard';
    }
  }, [ssoToken, partnerObject, partnerObject?.auth_token]);

  // console.log('here is the partnerObject in PartnerContextProvider: ', partnerObject);
  // console.log('here is urlSplit in PartnerContextProvider: ', urlSplit);

  // const sessionObject = useSession();
  // console.log('here is the sessionObject in PartnerContextProvider: ', sessionObject);

  // console.log('here is urlSplit: ', urlSplit);
  // if(urlSplit.length > 1){
  //   // console.log('here is urlSplit[0]: ', urlSplit[0]);
  //   console.log('here is usePartner(urlSplit[0]): ', usePartner(urlSplit[0]));
  // }
  // else {
  //   console.log('so urlSplit.length is not greater than 1');
  // }
  // console.log('here is the partnerObject in PartnerContextProvider: ', partnerObject);
  return (
    <PartnerContext.Provider
      value={{
        actions: {},
        state: {
          ...partnerObject?.partner,
          userRole:
            partnerObject && partnerObject.user && partnerObject.user.user_role
              ? partnerObject.user.user_role
              : 'Logged Out',
        },
      }}
      {...props}
    >
      {children}
    </PartnerContext.Provider>
  );
};
